module.exports = __webpack_public_path__ + "static/img1-294eb2749dcef0f747ac45a2a2416615.jpg";